import React from "react";
import { shape, string, bool, arrayOf, object } from "prop-types";
import { SocialShareButtons } from "./SocialShareButtons";
import { RCL as useTranslation } from "../RCL";

const SocialShareButtonsConnector = ({ data, location }) => {
	const publishedOnLabel = useTranslation({ searchKey: "published-on" });
	const shareLabel = useTranslation({ searchKey: "share" });

	return (
		<SocialShareButtons
			locale={data.node_locale}
			displayDate={data.displayDate}
			socialShareTitle={data.socialShareTitle}
			socialShareImage={data.socialShareImage.file.url}
			displayFacebookLink={data.displayFacebookLink}
			displayPinterestLink={data.displayPinterestLink}
			displayTwitterLink={data.displayTwitterLink}
			twitterHandle={data.twitterHandle}
			twitterHashtags={data.twitterHashtags}
			location={location}
			labels={{
				publishedOn: publishedOnLabel,
				share: shareLabel,
			}}
		/>
	);
};

SocialShareButtonsConnector.propTypes = {
	data: shape({
		node_locale: string,
		displayDate: string,
		socialShareTitle: string,
		socialShareImage: shape({
			file: shape({
				url: string,
			}),
		}),
		displayFacebookLink: bool,
		displayPinterestLink: bool,
		displayTwitterLink: bool,
		twitterHandle: string,
		twitterHashtags: arrayOf(string),
	}),
	location: object,
};
SocialShareButtonsConnector.defaultProps = {
	data: null,
	location: {},
};

export default SocialShareButtonsConnector;
export { SocialShareButtonsConnector };
